import { NavParams, ViewController } from 'ionic-angular';
import { Component } from '@angular/core';

@Component({
    selector: 'more-details',
    templateUrl: 'more-details.html'
})
export class MoreDetails {

    details: any = [];
    category: string;

    constructor(public viewCtrl: ViewController, public params: NavParams,) {

    }

    /**
     * Displays the given info
     */
    ionViewDidLoad() {
        this.details.push(this.params.get('details'));
        this.category = this.params.get('category');
    }

    /**
     * Closes the more detail view
     */
    dismiss() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/detail/more-details.ts